module.exports = __webpack_public_path__ + "img/lachsrollenfrontalshow.583921d1.jpg";